module.exports = __webpack_public_path__ + "03_glasses_blue.be888b17.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer4/03_glasses_blue.png
// module id = Lyie
// module chunks = 0